<template>
    <div>
        <el-row>
          <ForestryMultiValueFields 
            v-for="(data, idx) in context"
            :key="idx"
            :index="idx"
            :mode="mode"
            :handle_dynamic_form_update="inner_handle_dynamic_form_update"
            :preloaded_data="context[idx]"
            :preloaded_data_update_flag="inner_preloaded_data_update_flag"
            :remove_data="remove_data"
            @update-valid="(valid)=>{notify_valid(valid)}"
          />
        </el-row>
        <el-row v-if="mode==='edit' || mode==='add'">
          <el-button @click="add_data()" icon="el-icon-plus" />
          <el-button @click="remove_data()" icon="el-icon-minus" />
        </el-row>
    </div>
</template>

<script>
import ForestryMultiValueFields from '@/components/backstage/MultiValueForm/ForestryMultiValueFields.vue'

export default {
    components: {
      ForestryMultiValueFields
    },
    props: ['name','mode','handle_dynamic_form_update','preloaded_data',
      'preloaded_data_update_flag'],
    data() {
      return {
        context: [],
        inner_preloaded_data_update_flag: 0
      }
    },
    watch: {
      preloaded_data_update_flag: function () {
          this.update_form(this.preloaded_data)
          this.inner_preloaded_data_update_flag += 1
      },
      preloaded_data: function (data) {
          this.update_form(data)
          this.inner_preloaded_data_update_flag += 1
      }
    },
    created () {
      console.log('ForestryMultiValueForm::created(): preloaded_data:', this.preloaded_data)
      this.update_form(this.preloaded_data)
    },
    methods: {
      create_data () {
        return {'business_district':null, 'forest_squad': null}
      },
      update_form (form_data) {
        if (!Array.isArray(form_data)) {
          console.log('ForestryMultiValueForm: preloaded data must be an array')
          this.context = []
          return
        }
        else {
          this.context = JSON.parse(JSON.stringify(form_data))
        }
      },
      remove_data (index) {
        if (typeof index === 'undefined' || index === null) {
          this.context.pop()
        }
        else {
          this.context.splice(index, 1)
        }
        if (this.handle_dynamic_form_update) {
          this.handle_dynamic_form_update(this.name, this.context)
        }
        this.inner_preloaded_data_update_flag += 1
      },
      add_data() {
        this.context.push(this.create_data())
        if (this.handle_dynamic_form_update) {
          this.handle_dynamic_form_update(this.name, this.context)
        }
        this.inner_preloaded_data_update_flag += 1
      },
      inner_handle_dynamic_form_update (key, value, index) {
        //debugger
        this.$set(this.context[index], key, value)
        if (this.handle_dynamic_form_update) {
          this.handle_dynamic_form_update(this.name, this.context)
        }
      },
      notify_valid(valid) {
        this.$emit('update-valid', valid)
      }
    }
  };
</script>

<style>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
